<template>
  <div>
    <div class="input-tips">
      <i class="el-icon-info" style="color: #409EFF; margin-right: 5px;" />
      <span>支持多个车牌号，每个车牌号请以逗号","分割，最多支持300个车牌号</span>
    </div>

    <el-input
      v-model="batchPlates"
      type="textarea"
      :rows="10"
      placeholder="请在此输入车牌号,示例:鲁B88888,鲁A12345"
      style="width: 100%; margin-top: 15px;"
      class="batch-textarea"
    />

    <div class="plate-count">
      <span>
        <i class="el-icon-document" style="margin-right: 5px;" />
        已识别车牌号：<strong style="color: #409EFF;">{{ parsedPlates.length }}</strong>
        个
      </span>
    </div>

    <div v-if="parsedPlates.length > 300" class="warning-tip">
      <i class="el-icon-warning" style="color: #E6A23C; margin-right: 5px;" />
      <span style="color: #E6A23C;">车牌号较多，建议分批查询以获得更好的性能</span>
    </div>

    <div style="text-align: right;margin-top:20px;">
      <el-button
        icon="el-icon-delete"
        @click="clearBatchInput"
      >清空</el-button>
      <el-button
        type="primary"
        icon="el-icon-check"
        @click="confirmBatchInput"
      >确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BatchVehiclePlate",
  props: {
    codes: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      batchPlates: ""
    };
  },
  computed: {
    // 解析批量输入的车牌号（换行/中英文逗号分隔）
    parsedPlates() {
      if (!this.batchPlates.trim()) return [];
      return this.batchPlates
        .split(/[\n\r]+/)
        .map(line => line.split(/[,，]+/))
        .flat()
        .map(code => code.trim())
        .filter(code => code.length > 0);
    }
  },
  watch: {
    codes: {
      handler(newValue) {
        this.batchPlates = newValue;
      },
      immediate: true
    },
    parsedPlates: {
      handler(newValue) {
        if (newValue.length > 300) {
          this.$message({
            message: "最多只能输入300个车牌号",
            type: "warning"
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    confirmBatchInput() {
      this.$emit("confirmBatchInput", this.parsedPlates);
    },
    clearBatchInput() {
      if (this.parsedPlates.length === 0) return;
      this.$confirm("确认清空所有已输入的车牌号吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.batchPlates = "";
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped lang="scss">
.input-tips {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f0f9ff;
  border-left: 4px solid #409eff;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
}

.batch-textarea {
  .el-textarea__inner {
    font-family: "Courier New", monospace;
    line-height: 1.6;
    resize: vertical;
    border-radius: 6px;

    &:focus {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
    }
  }
}

.plate-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  font-size: 13px;
  color: #606266;
  border: 1px solid #e4e7ed;
}

.warning-tip {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #fdf6ec;
  border-left: 4px solid #e6a23c;
  border-radius: 4px;
  font-size: 12px;
}
</style>
